import { render, staticRenderFns } from "./button-goto-comp-v2.vue?vue&type=template&id=b0dfeb44&"
import script from "./button-goto-comp-v2.vue?vue&type=script&lang=ts&"
export * from "./button-goto-comp-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports